// components/routing/RouteGuards.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export function PublicRoute({ children }) {
  return children;
}

export function AuthenticatedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export function PersonalRoute({ children }) {
  const { isAuthenticated, accountType } = useAuth();
  return isAuthenticated && accountType === "personal" ? (
    children
  ) : (
    <Navigate to="/dashboards" replace />
  );
}

export function BusinessRoute({ children }) {
  const { isAuthenticated, accountType } = useAuth();
  return isAuthenticated && accountType === "business" ? (
    children
  ) : (
    <Navigate to="/dashboards" replace />
  );
}
